<div class="row wd-header">
  <a class="logo" [routerLink]="['']">
    <!--<h1>{{appName}}</h1>-->
  </a>
  <nav class="navbar navbar-expand-sm navbar-light bg-light">
    <a *ngIf="userName" class="navbar-brand" href="#" style="cursor:default">{{userName}}</a>
    <button class="navbar-toggler" type="button" [matMenuTriggerFor]="mobileMenu" #mobileMenuTrigger="matMenuTrigger" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarItems">
      <ul class="navbar-nav mr-auto">
        <li *ngIf="isCreator" class="nav-item hvr-float" [routerLink]="['/dashboard']"
             title="{{ 'menu_workflows' | translate }}">
          <a class="nav-link">
            <img src="/assets/img/navbar/workflow-list.svg" class="workflow-list" />
          </a>
        </li>
        <li *ngIf="isReviewer" class="nav-item hvr-float" [routerLink]="['/workflowreport']" title="{{ 'menu_reports' | translate }}">
          <a class="nav-link">
            <img src="/assets/img/navbar/report-list.svg" class="report-list" />
          </a>
        </li>
        <li *ngIf="isTechManager || isDesignerManager" class="nav-item hvr-float" [routerLink]="['/groups']" title="{{ 'menu_groups' | translate }}">
          <a class="nav-link">
            <img src="/assets/img/navbar/tech-group.svg" class="add-workflow" />
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [matMenuTriggerFor]="configuration" #configTrigger="matMenuTrigger">
            <img src="/assets/img/navbar/config.svg" class="config-app" title="{{ 'menu_config' | translate }}" />
          </a>
          <mat-menu #configuration="matMenu" class="header-config-menu" xPosition="before">
            <button mat-menu-item [matMenuTriggerFor]="languages">
              <img src="/assets/img/navbar/lang.svg" class="menu-icon" /> {{ 'menu_language' | translate }}
            </button>
            <a mat-menu-item href="https://manual.processeye.wideum.com/" target="_blank">
              <img src="/assets/img/navbar/help.svg" class="menu-icon" /> {{ 'user_manual' | translate }}
            </a>
            <button mat-menu-item (click)="openReportIssue()">
              <img src="/assets/img/navbar/send-error.svg" class="menu-icon" /> {{ 'menu_report_issue' | translate }}
            </button>
            <button mat-menu-item (click)="Logout()">
              <img src="/assets/img/navbar/log-out.svg" class="menu-icon" /> {{ 'menu_logout' | translate }}
            </button>
          </mat-menu>
        </li>
      </ul>
    </div>
  </nav>
</div>

<!-- Responsive: real Material menu, same building block as the desktop settings dropdown -->
<mat-menu #mobileMenu="matMenu" class="header-config-menu" xPosition="before">
  <a mat-menu-item *ngIf="isCreator" [routerLink]="['/dashboard']">
    <img src="/assets/img/navbar/workflow-list.svg" class="menu-icon" /> {{ 'menu_workflows' | translate }}
  </a>
  <a mat-menu-item *ngIf="isReviewer" [routerLink]="['/workflowreport']">
    <img src="/assets/img/navbar/report-list.svg" class="menu-icon" /> {{ 'menu_reports' | translate }}
  </a>
  <a mat-menu-item *ngIf="isTechManager || isDesignerManager" [routerLink]="['/groups']">
    <img src="/assets/img/navbar/tech-group.svg" class="menu-icon" /> {{ 'menu_groups' | translate }}
  </a>
  <button mat-menu-item [matMenuTriggerFor]="languages">
    <img src="/assets/img/navbar/lang.svg" class="menu-icon" /> {{ 'menu_language' | translate }}
  </button>
  <a mat-menu-item href="https://manual.processeye.wideum.com/" target="_blank">
    <img src="/assets/img/navbar/help.svg" class="menu-icon" /> {{ 'user_manual' | translate }}
  </a>
  <button mat-menu-item (click)="openReportIssue()">
    <img src="/assets/img/navbar/send-error.svg" class="menu-icon" /> {{ 'menu_report_issue' | translate }}
  </button>
  <button mat-menu-item (click)="Logout()">
    <img src="/assets/img/navbar/log-out.svg" class="menu-icon" /> {{ 'menu_logout' | translate }}
  </button>
</mat-menu>

<mat-menu #languages="matMenu" class="header-config-menu" xPosition="before">
  <button mat-menu-item (click)="setLang('en')">{{ 'menu_english' | translate }}</button>
  <button mat-menu-item (click)="setLang('es')">{{ 'menu_spanish' | translate }}</button>
  <button mat-menu-item (click)="setLang('fr')">{{ 'menu_french' | translate }}</button>
  <button mat-menu-item (click)="setLang('it')">{{ 'menu_italian' | translate }}</button>
  <button mat-menu-item (click)="setLang('pt')">{{ 'menu_portuguese' | translate }}</button>
  <button mat-menu-item (click)="setLang('cs')">{{ 'menu_czech' | translate }}</button>
</mat-menu>
